import { UnorderedList } from 'atoms'

export const CollapsibleContentCompCoach = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 10 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Selbstbewusst sein und Persönlichkeit zeigen für Frauen
    </h3>
    <UnorderedList items={[
      'Fragen zur Identität',
      'Lebenssinn, Lebenswerte und Lebensaufgabe',
      'Lebensplan und Lebensziele klären',
      `Eigenwertschätzung zeigen durch Verfolgung der eigenen Ziele und Aufstellung eigener Regeln`,
      'Schutz vor Manipulationen',
      'Selbstsichere Körpersprache',
      'Und vieles mehr',
    ]} type="check" />
    <h3>
      Ressourcenklärung für Frauen
    </h3>
    <UnorderedList items={[
      'Stärkenanalyse und bewusster Einsatz',
      'Ressourcen erkennen und einsetzen',
      'Motivationsraster aufstellen und nutzen',
      'Positive Glaubenssätze freilegen',
      'Netzwerkaufbau und Netzwerknutzung',
    ]} type="check" />
    <h3>
      Selbstmanagementkompetenzen für Frauen
    </h3>
    <UnorderedList items={[
      'Ziele setzen und erreichen',
      'Nützliches Handwerkszeug einsetzen',
      'Planung, Regeln, Methoden',
      'Blockaden lösen',
      'Selbstdisziplin trainieren',
    ]} type="check" />
    <h3>
      Kommunikations-und Konfliktkompetenzen von A bis Z für Frauen
    </h3>
    <UnorderedList items={[
      'Wie funktioniert Warnehmung?',
      'Kommunikationsmodelle: Chancen und Risiken',
      'Von Small Talk bis zu Schlagfertigkeit',
      'Verhandlungsführung und Mediationsprozesse',
      'Souveräner Umgang mit Macht und Manipulation',
      'Auflösung schädlicher Glaubenssätze',
      'Konstruktives Abgrenzungsverhalten',
    ]} type="check" />
    <h3>
      Balancekompetenzen für Frauen
    </h3>
    <UnorderedList items={[
      'Stress verstehen',
      'Ziele, Rollen, Kompetenzen klären',
      'Kraft.Balance.Stabilität',
      'Resilienz und Abgrenzung',
      'Schutzkompetenzen Burn Out',
      'Entspannungstechniken bewusst nutzen',
    ]} type="check" />
  </>
)

export const CollapsibleResourceDesc = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 2 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Ressourcenklärung für Frauen
    </h3>
    <UnorderedList items={[
      'Stärkenanalyse und bewusster Einsatz',
      'Ressourcen erkennen und bewusst einsetzen',
      'Motivationsraster aufstellen und nutzen',
      'Positive Glaubenssätze freilegen und konsequent nutzen',
      'Netzwerkaufbau und Netzwerknutzung',
    ]} type="check" />
  </>
)

export const CollapsibleContentComComp = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 2 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Kommunikations-und Konfliktkompetenzen von A bis Z für Frauen
    </h3>
    <UnorderedList items={[
      'Wie funktioniert Wahrnehmung?',
      'Kommunikationsmodelle: Chancen und Risiken',
      'Von Small Talk bis zu Schlagfertigkeit',
      'Verhandlungsführung und Mediationsprozesse',
      'Souveräner Umgang mit Macht und Manipulation',
      'Auflösung schädlicher Glaubenssätze',
      'Konstruktives Abgrenzungsverhalten',
    ]} type="check" />
  </>
)

export const CollapsibleContentSelfConf = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 2 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Selbstbewusst sein und eigene Regeln aufstellen: für Frauen
    </h3>
    <UnorderedList items={[
      'Fragen zur Identität',
      'Lebenssinn, Lebenswerte und Lebensaufgabe',
      'Lebensplan und Lebensziele klären',
      'Eigenschaften selbstbewusster Menschen',
      `Eigenwertschätzung zeigen durch Verfolgung der eigenen Ziele und Aufstellung eigener Regeln`,
      'Schutz vor Manipulationen',
      'Selbstsichere Körpersprache',
      'Und vieles mehr',
    ]} type="check" />
  </>
)

export const CollapsibleContentSelfMan = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 2 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Selbstmanagementkompetenzen für Frauen
    </h3>
    <UnorderedList items={[
      'Ziele setzen und erreichen',
      'Nützliches Handwerkszeug einsetzen',
      'Planung, Regeln, Methoden',
      'Blockaden lösen',
      'Selbstdisziplin trainieren',
    ]} type="check" />
  </>
)

export const CollapsibleContentBalance = () => (
  <>
    <p>
      {`Einfach gut aufgestellt sein-der Durchbruch für den beruflichen Erfolg 2 Tage a 5 Stunden`}
    </p>
    <p>
      Termine nach Absprache, Teilzeit oder Vollzeit Wochenende oder Woche
    </p>
    <h3>
      Balancekompetenzen für Frauen
    </h3>
    <UnorderedList items={[
      'Stress verstehen',
      'Ziele, Rollen, Kompetenzen klären',
      'Kraft. Balance. Stabilität',
      'Resilienz und Abgrenzung',
      'Schutzkompetenzen Burn Out',
      'Entspannungstechniken bewusst nutzen',
    ]} type="check" />
  </>
)
